import Vue from 'vue'

Vue.prototype.$ask = function (func: Function) {
  return this.$confirm('确定要执行此操作吗?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(async () => {
    await func()
  }).catch()
}
